// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__4S733","title":"Tile_title__Zg8fn","category":"Tile_category__isgYT","amount":"Tile_amount__U0Dmg","income":"Tile_income__S+cmd"};